import { validForm } from './form-validation';

function signUpInitiate()
{
	var createAccountButton = document.getElementById("sign-up-button");
	createAccountButton.addEventListener("click", sendSignUpData);
}

function sendSignUpData()
{	
	var signUpForm = document.getElementById("sign-up-form");
	
	var blurEvent = document.createEvent("Event");
	blurEvent.initEvent("blur", false, true);
	blurEvent.submission = false;
	blurEvent.showFeedback = false;
	
	if (validForm(signUpForm, blurEvent) == true)
	{
		var createAccountButton = document.getElementById("sign-up-button");
		createAccountButton.removeEventListener("click", sendSignUpData);
		// enable facebook tracking later
		// fbq('track', 'StartTrial');
	}
}

export default signUpInitiate;
